export enum Env {
  Production,
  Staging,
  Development,
  Test,
}
